<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     新订单
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="em-order-create flex column">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>

    <el-row :gutter="20" style="padding-bottom: 70px;">
      <el-col :span="6">
        <em-product-picker @success="onProductPickerSuccess" />
      </el-col>
      <el-col :span="18">
        <el-card>
          <el-scrollbar style="height: calc(100vh - 230px);">
            <el-form ref="postForm" label-position="left" label-width="120px" :model="formData" :rules="formRules">
              <el-form-item label="客户" prop="memberid">
                <f-member-selector v-model="formData.memberid" width="240px" @change="onMemberChange" />
              </el-form-item>
              <el-form-item label="结算">
                <el-radio-group v-model="formData.pay_type">
                  <el-radio :label="1">现货现款</el-radio>
                  <el-radio :label="2">货到付款</el-radio>
                  <el-radio :label="3">月结货款</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="formData.remark" type="textarea" :rows="1" />
              </el-form-item>
            </el-form>
            <el-table
              v-show="formData.items.length > 0"
              ref="listTable"
              :key="itemsTableKey"
              :data="formData.items"
              row-key="skuid"
            >
              <el-table-column type="index" width="50" />
              <el-table-column label="明细" min-width="280">
                <template slot-scope="scope">
                  <el-input v-model="formData.items[scope.$index].skuTitle" />
                </template>
              </el-table-column>
              <el-table-column label="数量" min-width="160" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="formData.items[scope.$index].num" :min="1" :step="1" :precision="0" style="width: 150px;" />
              </template>
            </el-table-column>
              <el-table-column label="面价" min-width="80" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.market_price | currency }}</span>
                </template>
              </el-table-column>
              <el-table-column label="单价" min-width="100" align="center">
                <template slot-scope="scope">
                  <el-input-number v-model="formData.items[scope.$index].customPrice" :min="0" :precision="2" :controls="false" style="width: 100px;" />
                </template>
              </el-table-column>
              <el-table-column label="小计" min-width="70" align="right">
                <template slot-scope="scope">
                  <span>{{ scope.row.num * scope.row.customPrice | currency }}</span>
                </template>
              </el-table-column>
              <el-table-column width="50">
                <template slot-scope="scope">
                  <span class="text-muted" role="button" @click="deleteItem(scope.row)">
                    <i class="el-icon-error" />
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </el-card>
      </el-col>
    </el-row>

    <div class="main-footer-fix" :style="{ 'left': $store.state.commonStore.collapse === 1 ? '240px' : '340px' }">
      <el-row style="width: 100%;">
        <el-col :span="8" :offset="8" class="text-center">
          <p class="mt-sm mb-sm">
            <el-button type="primary" :disabled="formData.items.length === 0 || !formData.memberid" @click="onCreateOrderSubmit">提交</el-button>
          </p>
        </el-col>
        <el-col :span="8" class="text-right" style="padding-right: 60px;">
          <p class="mt-sm mb-sm">
            <span>金额总计： </span>
            <span class="font-2x" :class="{ 'text-warning': amountTotal > 0 }">{{ amountTotal | currency }}</span>
          </p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import EmProductPicker from "./components/ProductPicker";
import { createOrderApi } from '@/api/ei/eiMallApi'
export default {
  name: "EmOrderCreate",
  components: {
    EmProductPicker
  },
  data() {
    return {
      loading: false,
      postLoading: false,
      formData: {
        memberid: null,
        pay_type: 1,
        remark: null,
        items: []
      },
      formRules: {
        memberid: [
          { required: true, message: "客户不能为空", trigger: "change" }
        ]
      },
      currentMember: null,
      itemsTableKey: 0,
    };
  },
  computed: {
    amountTotal() {
      return this.formData.items.reduce((acc, cur) => {
        acc += parseFloat(cur.selling_price) * parseFloat(cur.num);
        return acc;
      }, 0);
    }
  },

  created() {},

  methods: {
    onMemberChange(member) {
      if (member && Number.isInteger(member.customer_level) && this.formData.items.length) {
        this.formData.items.forEach(item => {
          if (item.advanced_prices.length && (!this.currentMember || this.currentMember.customer_level !== member.customer_level)) {
            const advanced_price = item.advanced_prices.find(v => v.level === member.customer_level)
            if (advanced_price) {
              item.customPrice = advanced_price.price
            } else {
              item.customPrice = item.selling_price
            }
          }
        })
        this.itemsTableKey++
      }
      this.currentMember = member
    },
    onProductPickerSuccess(product) {
      for (const v of this.formData.items) {
        if (v.skuid === product.skuid) {
          this.formData.items[this.formData.items.indexOf(v)].num = v.num + 1
          return
        }
      }
      let selling_price = 0
      if (this.currentMember && this.currentMember.customer_level && product.advanced_prices.length) {
        selling_price = product.advanced_prices.find(v => v.level === this.currentMember.customer_level).price
      } else {
        selling_price = product.selling_price
      }

      Vue.set(product, "skuTitle", product.skuTitle);
      Vue.set(product, "market_price", product.market_price);
      Vue.set(product, "customPrice", product.customPrice);
      Vue.set(product, "num", 1);

      this.formData.items.push(product);
    },
    deleteItem(item) {
      const index = this.formData.items.indexOf(item);
      if (index > -1) {
        this.formData.items.splice(index, 1);
      }
    },
    onCreateOrderSubmit() {
      this.postLoading = true;
      const temp = {
        ...this.formData,
        items: this.formData.items.map(item => {
          return {
            productid: item.productid,
            product_snapshotid: item.product_snapshotid,
            sku_snapshotid: item.sku_snapshotid,
            skuid: item.skuid,
            num: item.num,
            selling_price: item.customPrice,
            market_price: item.market_price,
            item_title: item.skuTitle,
          }
        })
      }

      createOrderApi(temp).then(res => {
        this.postLoading = false
        if (!res.errno) {
          // 操作成功处理
          this.$message.success('订单创建成功！')
          this.$router.push('/em/order')
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        this.postLoading = false
        console.log(err)
      })
    }
  }
};
</script>

<style scoped lang="scss">
.em-order-create {
  .el-card {
    /deep/ .el-card__body {
      padding-right: 0;
    }
  }
  .el-scrollbar {
    /deep/ .el-scrollbar__wrap {
      padding-right: 20px;
    }
  }
}
</style>
